import Sortable from 'sortablejs/modular/sortable.complete.esm.js';


import eventBus from './event-bus';

function initSort() {

    const el = document.getElementById('sortableCard');
    const toggleSort = document.querySelector('.is-toggle-sort');

    if (el && toggleSort) {
        const sortable = Sortable.create(el, {
            animation: 150,
            ghostClass: 'is-sortable-ghost',
            handle: '.is-handle',
            disabled: true,
            multiDrag: true,
            selectedClass: 'is-sortable-selected',
            fallbackTolerance: 3,
            onEnd: function (evt) {
                sort(evt.to);
            }
        });

        toggleSort.addEventListener('change', function () {
            if (this.checked) {
                sortable.option('disabled', false);
                el.classList.add('sort-active')
            } else {
                sortable.option('disabled', true)
                el.classList.remove('sort-active')
            }
        });
    }

}

function sort(elements) {
    var rowIds = [];
    $(elements).children('li').each(function () {
        var rowId = $(this).attr('data-row-id');
        rowIds.push(rowId);
    });
    var cartId = $('.is-cart').attr('data-cart-id');
    window.axios.post(window.config.urls.sortProducts, {
        cart_id: cartId,
        rowIds: rowIds,
    });
}

initSort();

eventBus.on('cart-item-quantity-change', function () {
    initSort();
});
